import CheckoutError from './CheckoutError.js'

export default class GetPaymentMethodsCheckoutError extends CheckoutError {}
